import { FC } from 'react'

import { getAccessVisibilityIcon, getAccessVisibilityText } from './helpers'
import type { AboutServerSectionProps } from '../../types'

type ServerInfoProps = Pick<AboutServerSectionProps, 'serverInfoData'>

const ServerInfo: FC<ServerInfoProps> = ({ serverInfoData }) => (
  <div className="flex flex-col gap-xxs">
    <h1 className="text-2xl font-semibold text-gray-900">
      {serverInfoData.name}
    </h1>
    <div className="flex items-center gap-xxxs text-base text-gray-500">
      {getAccessVisibilityIcon(serverInfoData.accessVisibility)}
      {getAccessVisibilityText(serverInfoData.accessVisibility)}
      <span className="flex h-0.5 w-0.5 self-center rounded-full bg-gray-500" />
      {`v.${serverInfoData.version}`}
    </div>
  </div>
)

export default ServerInfo
